var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkFormSectionWrap"},[_c('other-card',{attrs:{"remarks":_vm.ruleForm.comment},on:{"update:remarks":function($event){return _vm.$set(_vm.ruleForm, "comment", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }